import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { IstPublicationsViewModalComponent } from './ist-publications-view-modal/ist-publications-view-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject } from 'src/app/models/common';

@Component({
  selector: 'app-ist-publications',
  templateUrl: './ist-publications.component.html',
  styleUrls: ['./ist-publications.component.scss']
})
export class IstPublicationsComponent implements OnInit {
  columnDefs:any=[];
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  publicationsearchform: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  typeOptions = [];
  contentOptions = [];


  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
    private datepipe: DatePipe

  ) {
  }

  ngOnInit() {
    this.permission = this.commonService.getPagePermission("IST11").toLowerCase();
    this.userType = this.userService.getUserType();
    this.publicationsearchform = new UntypedFormGroup({
      Type: new UntypedFormControl(null),
      Content: new UntypedFormControl(null),
      Title: new UntypedFormControl(null),
      StartDateStr: new UntypedFormControl(null),
      EndDateStr: new UntypedFormControl(null),
      StartDateO : new UntypedFormControl(null),
      EndDateO:new UntypedFormControl(null),
      SubmittedDateFrom:new UntypedFormControl(null),
      SubmittedDateTo:new UntypedFormControl(null)
    });
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      const modalRef = this.modalService.open(MessageBoxComponent, { });
      modalRef.componentInstance.Content={ heading: '', content: { heading: '', description: 'Please save General information details to navigate to Publications', operation: { hasConfirm: false } } } 
      modalRef.result.then((result) => {
        this.router.navigate(['/home/ist/my-applications/application-ext/:' + this.ApplicationID + '/general_information_request'],
          { skipLocationChange: true, queryParams: { id: this.ApplicationID, app_ext: true, module: "ist", screen_type: "my-applications" } })
      });
      return false;
    }
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });

    if (this.userType == "E") {
      this.columnDefs = [
        {
          "headerName": "Publication Type",
          "field": "Type",
          "tooltipField": "type"
        },
        {
          "headerName": "Content",
          "field": "Content",
          "tooltipField": "content"
        },
        {
          "headerName": "Title",
          "field": "Title",
          "tooltipField": "Title"
        },
        {
          "headerName": "Submitted Date",
          "field": "SubmittedDateStr",
          "tooltipField": "SubmittedDateStr"
        },
        {
          "headerName": "Status",
          "field": "Status",
          "tooltipField": "Status"
        }
      ];
    } else {
      this.columnDefs = [
        {
          "headerName": "Type",
          "field": "Type",
          "tooltipField": "type"
        },
        {
          "headerName": "Content",
          "field": "Content",
          "tooltipField": "content"
        },
        {
          "headerName": "Title",
          "field": "Title",
          "tooltipField": "Title"
        },
        {
          "headerName": "Submitted Date",
          "field": "SubmittedDateStr",
          "tooltipField": "SubmittedDateStr"
        }
      ];
    }


    this.tempoperations = [

    ];

    this.advanceSearch =
    {
      "fields": [
        {
          "label": "Type",
          "field": "type",
          "type": "text"
        },
        {
          "label": "Content",
          "field": "content",
          "type": "text"
        },
        {
          "label": "Title",
          "field": "title",
          "type": "text"
        }
      ]
    };

    this.GetMaserDropData();
    this.setSummary();
  }


  GetMaserDropData() {
    this.summaryService.getScreenDataForEdit("api/ISTPublications/GetMaserDropData?ApplicationID=" + this.ApplicationID + "&RecordID=" + "").subscribe(result => {
      this.typeOptions = result["MasterData1"];
      this.typeOptions = [{ label: "All", value: null, checked: true }].concat(this.typeOptions);
      this.contentOptions = result["MasterData2"];
      this.contentOptions = [{ label: "All", value: null, checked: true }].concat(this.contentOptions);
    });

  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }


  onCallbackOperation(opr) {
    opr.callback(this.summaryService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
   const ModelRef= this['self'].modalService.open(IstPublicationsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    ModelRef.componentInstance.Content={
      heading: 'View',
      content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
    }
  }

  add() {
    let modalRef = this['self'].modalService.open(IstPublicationsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      //ignoreBackdropClick: true,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
      modalRef.componentInstance.Content= {
        heading: 'Add',
        content: { id: "", ApplicationID: this.ApplicationID }
      }
    
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }

  edit(Service, toastrService) {

    let modalRef = this['self'].modalService.open(IstPublicationsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
      modalRef.componentInstance.Content={
        heading: "Edit",
        content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
      }
   
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }

  view(Service, toastrService) {

    let modalRef = this['self'].modalService.open(IstPublicationsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
      modalRef.componentInstance.Content={
        heading: "View",
        content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
      }
    
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }

  delete(Service, toastrService) {
    if (this['self'].selectedRow['SubmittedDateStr'] == null || this['self'].selectedRow['SubmittedDateStr'] == undefined || this['self'].selectedRow['SubmittedDateStr'] == "") {
      let id = this['self'].selectedRow['ID'];
      let title = this['self'].selectedRow['Title'];
      let modalRef= this["self"].modalService.open(DeleteBoxComponent,  { backdrop: false });
      modalRef.componentInstance.Content= { heading: 'Delete Publication',custommessage: 'Are you sure you want to delete the Publication ' + title + ' ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };

      modalRef.result.then(result => {
        if (result == "okclick") {
          Service.DeleteRecord('api/ISTPublications/Delete?RecordID=' + id).subscribe(summary => {
            if (summary["Status"] == 0) {
              this['self'].commonService.SuccessBanner('Publication ' + title + ' deleted successfully');
              this['self'].setSummary();
            }
            else {
              this.commonService.ValidationBanner("Referenced record Can't be Deleted ");
              // toastrService.error("Referenced record Can't be Deleted ");
            }
          });
        }
      })
    }
    else {
      this.commonService.ValidationBanner("Record Can't be deleted");
      //this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Record Can't be deleted" } } });
    }
  }


  setSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData("api/ISTPublications/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  setOperations(RawData: any): any {

    if (this.permission == "new") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        },
        {
          "name": "Add New Publication",
          "id": "add"
        }
      ];
    }

    if (this.permission == "edit") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        }
      ];
    }

    this.setDef(this.tempoperations);
    RawData.forEach(element => {
      if (element.Status == "Submitted") {
        let tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          }
        ];
        if (this.permission == "new") {
          tempoperations2.push({
            "name": "Add New Publication",
            "id": "add"
          })
        }
        element["Operations"] = this.setDef(tempoperations2);
      }

      if (element.Status == "Drafted") {
        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (this.permission == "view") {
        this.tempoperations = [          
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }    
    });
    return RawData;
  }

  setDef(parmoperations: any): any {
    //this.tempoperations = parmoperations;
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  getSearchSummary(searchObject) {
    this.summaryService.fetchSearchData("api/ISTPublications/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }
  SearchClear() {
    this.publicationsearchform.reset();

    //  this.setSummary();
  }
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }
  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  AdvanceSearch() {
    debugger;
    var formData = this.publicationsearchform.value;
    // if (!this.validateSearch()) {
    formData["ApplicationID"] = this.ApplicationID;
    if (formData["SubmittedDateFrom"] != null && formData["SubmittedDateFrom"] != "" && formData["SubmittedDateFrom"] != 'Invalid Date') {
      formData["StartDateStr"] = this.datepipe.transform(formData["SubmittedDateFrom"], 'dd-MMM-yyyy');
      formData["StartDateO"] = this.Full_Start_Date;

    }
    if (formData["SubmittedDateTo"] != null && formData["SubmittedDateTo"] != "" && formData["SubmittedDateTo"] != 'Invalid Date') {
      formData["EndDateStr"] = this.datepipe.transform(formData["SubmittedDateTo"], 'dd-MMM-yyyy');
      formData["EndDateO"] = this.Full_End_Date;
    }
    formData["SubmittedDateFrom"] = null;
    formData["SubmittedDateTo"] = null;
    this.getSearchSummary(formData);
    // } else {
    //   this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: "Please enter at least one criteria to perform search" } } });

    // }
  }
  onAdvanceSearchOperation(searchFiletrs) {

  }

  validateSearch() {
    let hasValue: Boolean = true;
    if (this.publicationsearchform.controls["StartDate"].value != null && this.publicationsearchform.controls["StartDate"].value != undefined && this.publicationsearchform.controls["StartDate"].value != 'Invalid Date') {
      hasValue = false;
    }

    if (this.publicationsearchform.controls["EndDate"].value != null && this.publicationsearchform.controls["EndDate"].value != undefined && this.publicationsearchform.controls["EndDate"].value != 'Invalid Date') {
      hasValue = false;
    }

    if (this.publicationsearchform.controls["Content"].value != null && this.publicationsearchform.controls["Content"].value != undefined && this.publicationsearchform.controls["Content"].value != "") {
      hasValue = false;
    }

    if (this.publicationsearchform.controls["Type"].value != null && this.publicationsearchform.controls["Type"].value != undefined && this.publicationsearchform.controls["Type"].value != "") {
      hasValue = false;
    }

    if (this.publicationsearchform.controls["Title"].value != null && this.publicationsearchform.controls["Title"].value != undefined && this.publicationsearchform.controls["Title"].value != "") {
      hasValue = false;
    }
    return hasValue;
  }
}
